import { t } from '@/features/i18n/utils';
import { OfferBreadcrumbs } from '@/features/subcontractor-bids/components/offer-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { Icon } from '@/ui/components/icon';
import { FolderIcon } from '@hugeicons-pro/core-stroke-rounded';
import { BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import {
  FilesDetailPageBreadcrumbPage,
  FilesDetailPage,
} from '@/features/documents/components/files-page/files-detail-page';
import { documentVersionsQuery } from '@/features/documents/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId',
)({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.query({ ...documentVersionsQuery(params.documentId), staleTime: 'static' }),
});

function RouteComponent() {
  const { projectId, workspaceId, procurementId, subcontractorId, documentId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <OfferBreadcrumbs subcontractorId={subcontractorId}>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files"
            params={{ projectId, workspaceId, procurementId, subcontractorId }}
          >
            <Icon icon={FolderIcon} />
            {t({ en: 'Files', nb: 'Filer' })}
          </BreadcrumbLink>
          <BreadcrumbPage>
            <FilesDetailPageBreadcrumbPage documentId={documentId} />
          </BreadcrumbPage>
        </OfferBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <FilesDetailPage documentId={documentId} />
    </>
  );
}
